import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import A from '../../../common/A';
import { Header } from "../common";
import { URL } from '../../../../constant';
import { errorMessage } from '../../../../redux/errorState';

const { JOIN, POLICY } = URL.ACCOUNT;

/**
 * 매쓰피드 회원가입
 */
function Policy() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [terms, setTerms] = useState({
    terms: false,
    privacy: false,
    safeguard: false,
    marketing: false,
  });

  const onChange = (e) => {
    const name = e.target.name;
    const checked = e.target.checked;
    const temp = terms;
    
    if (name === "all") {
      
      setTerms({
        terms: checked,
        privacy: checked,
        safeguard: checked,
        marketing: checked,
      });
    } else {
      temp[name] = checked;
      setTerms({...temp});
    }
  }

  const onSubmit = () => {
    if (!terms.terms || !terms.safeguard || !terms.privacy) {
      dispatch(errorMessage('msg', '필수약관에 동의해주세요.'));
      return;
    }
    history.push(JOIN.I);
  }

  const handlePage = (path) => {
    history.push(path);
  }

  return (
    <React.Fragment>
      <Header title="회원가입" />
      <div className="layout-def log_in agree with_bottom_area">
        <div className="container">
          <div className="inner">
            <div className="center_wrap2">
              <div className="noti_wrap">
                <h1 className="noti1">서비스 이용 동의</h1>
                <div className="noti2">
                  만 14세 미만의 학습자는
                  <br />
                  부모 혹은 법정대리인의 동의가 필요합니다.
                </div>
              </div>
              <div className="chk_wrap">
                <div className="upper_box">
                  <div className="custom-radio-wrap custom-radio-white">
                    <input
                      type="checkbox"
                      id="agree"
                      name="all"
                      checked={terms.terms && terms.safeguard && terms.privacy && terms.marketing}
                      onChange={onChange}
                    />
                    <label htmlFor="agree">전체 동의합니다.</label>
                  </div>
                </div>
                <div className="lower_box">
                  <article className="cls">
                    <input
                      id="agree1"
                      name="terms"
                      type="checkbox"
                      checked={terms.terms}
                      onChange={onChange}
                    />
                    <label htmlFor="agree1">이용약관 동의 (필수)</label>
                    <div className="right">
                      <button
                        className="arr"
                        onClick={() => handlePage(POLICY.TERMS)}
                      >
                        <img
                          src="static/images/icon/link_join_48x48@2x.png"
                          alt=""
                        />
                      </button>
                    </div>
                  </article>
                  <article className="cls">
                    <input
                      id="agree2"
                      name="privacy"
                      checked={terms.privacy}
                      type="checkbox"
                      onChange={onChange}
                    />
                    <label htmlFor="agree2">
                      개인정보 수집 및 이용 동의 (필수)
                    </label>
                    <div className="right">
                      <button
                        className="arr"
                        onClick={() => handlePage(POLICY.PRIVACY)}
                      >
                        <img
                          src="static/images/icon/link_join_48x48@2x.png"
                          alt=""
                        />
                      </button>
                    </div>
                  </article>
                  <article className="cls">
                    <input
                      id="agree3"
                      name="safeguard"
                      checked={terms.safeguard}
                      type="checkbox"
                      onChange={onChange}
                    />
                    <label htmlFor="agree3">
                      만14세 이상임을 확인합니다. (필수)
                    </label>
                  </article>
                  <article className="cls">
                    <input
                      id="agree4"
                      name="marketing"
                      checked={terms.marketing}
                      type="checkbox"
                      onChange={onChange}
                    />
                    <label htmlFor="agree4">마케팅 수신 동의 (선택)</label>
                    <div className="right">
                      <button
                        className="arr"
                        onClick={() => handlePage(POLICY.MARKETING)}
                      >
                        <img
                          src="static/images/icon/link_join_48x48@2x.png"
                          alt=""
                        />
                      </button>
                    </div>
                  </article>
                </div>
              </div>
            </div>
            <div className="bottom_wrap btn_wrap">
              <A
                className="btn btn-white"
                onClick={onSubmit}
              >
                다음
              </A>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Policy;